import { Icon, iconList } from "@innovationnorway/cl-icons";
import cn from "clsx";
import * as React from "react";
const InIcon = React.forwardRef(({ className, size, iconName, children, style, ...props }, ref) => {
    if (iconList.map((icon) => icon.name).includes(iconName)) {
        return (React.createElement(Icon, { name: iconName, className: cn(`in-icon-in--${size}`, className) }));
    }
    return false;
});
InIcon.displayName = "Icon";
export { InIcon };
//# sourceMappingURL=inIcon.js.map